import {createBrowserInspector} from '@statelyai/inspect';
import {setup} from 'xstate';
import {initialContext} from '../constant';
import {
  BuyTicketFlowActions,
  BuyTicketFlowActors,
  BuyTicketFlowChildMap,
  BuyTicketFlowContext,
  BuyTicketFlowEvents,
  BuyTicketFlowGuards,
} from '../type';
import {buyTicketFlowActions} from './actions';
import {buyTicketFlowActors} from './actors';
import {buyTicketFlowGuards} from './guards';

export const buyTicketFlowMachine = setup<
  BuyTicketFlowContext,
  BuyTicketFlowEvents,
  BuyTicketFlowActors,
  BuyTicketFlowChildMap,
  BuyTicketFlowActions,
  BuyTicketFlowGuards
>({
  actions: buyTicketFlowActions,
  actors: buyTicketFlowActors,
  guards: buyTicketFlowGuards,
}).createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QCMCuBPAKgSwMYGswAXAMQBsB7AdwGJAL2cBjBgbQAYBdRUABwtmyOwUAdpxAAPRABYATABoQ6RAA4AjADoVSgOwBmAKwqtKgGxKdW4yoC+V+Wix5CpSlTWAAZsAMdYERJmoBdxwJVjgDG1gDCrgDodgA1jgCljgLUzgBQtrBxIIDx8AsKiEgjSetJq0ix6kgCcesb6KiqSSsbyigg6kjpqOjrGRUosOprSukp6NnYYOATE5NTu3jSAHIOAHUuANrWAJ50x8eyiKfyCIkmZ2bn5hSVlBpXVtYjGkixqxvndxhY6LCxKAyD2w05jrrOLYeGAO0OARPGaAk1rwNultogtJJJGoihYzCx2kV8pYzghjBc1B0io8uh0WNJqq93o5Ri41AEQhEgTQIMIwGpsEIAG4UQhqMkjZzjal-IEIFns3AAQzSQgSoKS6wlGUQOiUsLUpQ6jWKKmkWL0GJ62maKhyLAsKnMyMkpKG5N5rn5tOBYAATo6KI61FwyOKAGaugC2XKtPK+VKCAsBQrZFDFEqlqxl4LlUIQkj0LGMGnaMiKKdKlV1LBMai0ehhDQqOmksOklocQcpsCd2DgAGUWVAyGAAJJCH2AVAnAC89gAAJwCl4yC49wE5t5QgYXCEaZHii0SpdQi4bCtLji4qGjWPhTxg3HU3YK2hO2uz2KAORyCVIkJ6kp0nZ-DEYulKi0yuFOcigWcTNTUumeHI92tYMjxPM8L27Psh1HJhpAfZJJ0hUBMlfeckSXb8MTaVFrk3Atc00PpwLrQ9GxbNsOzg68EJBHQUNlZ8MOhZVsI-L90V-LJUSUeElXMHppEqWEKM+SlQkAD9rAA9xwAWmcAGwWxxYtCtnYhAKi0K49G0MolCUSteiKDFinXdo9HaYkC2zHRJIPVxZMUlSmHvMEn3Q8REG03T9MVIzJBM3UcjhEt2g6UxsmeBybTUZzlJBZCPIhDTvK0ww-IeQzjMVUy+OMooNBMWFWlTbTjFi4MEtc5iUsTTTfJVfycqCvL8NMeESzKvo01hfpbDeQMpPGR0wFFCAsAoABVBsAEEAAVO0ADjXABzZ+lGWZSNOW5EbXDGiaptmsBFpW1aIxFcVNljNTPLSnZpHMa5iiJIpjBLKydT4rpDWaBcKkuRpU0qwbdsctQDsmzAZvmpa1poJ0XTdD1vT9ANaz2iHxqhmGTrh87hSjK7hBu+q2PSnoVCuGEOj0RUtGkYk5AKi44QZnLGfuaoJNB4bwdmQBBgcACJWAH1FkAHAnAB1VkXAFxlwBR0Y2oQmUJna+biwXRYl6X5YuomY3YaVH1S6c6YreFTGEwoWCqHQMSp4ocT0vpSrxS5rF5jH+ZmYWxYWKXZYVxHXXdT0iB9R1-TB9Xvc1v3tbl3Xo2ug3x1Qu6TZaXI3sMoHAbMDF-0EtMtQZ3ROj0AwqspDWRd8QAP7sWSWfflxXle2pko+DGv68b5uE8JpOSZT27jaTU2s4t3PrfzvjTRyFVNEke4QPMLoq-GbuG4WJvRZboPkdD8PI7VruY9rred4DxPiclYeya8zJx-NnP9Dz23Z8ePQVRLfY0yKcSLQe33HFBsRAABK2MjqwzOq3La7JVaexAcQCBh1obHVOmta++s2CGzTqPRqb10wVnyFoV2lYKx20-kWCsKYGgFnLCDQYiDILIMgWg6B8N94h1RhHdGwCWHgLYbjDBBNIyD1vjg1OrEH4+UIc0RmxoyGNGZnUSwuQy5dHuG9PKgCmH8PrKw1Bwj8YI2dMHFGYc0adwMYIox6D8ZYOTjg9y8Z05JhUHI4hiiGjkJUecKy1x-7hU6CaVQ69XCgJQTjexMCuEWKPnwiCNiolQLxmdRxQ8cHJVcfg9KHisTyJIUoihBUuhwieCUIyqgjCagGnopJG8ZjUkAKprclVL33uogSm1MqgFHpozIyds6blN0MZMSDN8gvCAQ074TSgitLvCPBqFMjA9Npv0pmlDGZFkKJIU00hUQ5GyOEtQNdFgBxFoAD0b1oMiVnAjkHcT7VzPuc+WVzRGXWwbg6RnT6ilHTIZao+gEQFlaHbA5RVNFKjEmWQwJyzkLAudc0xSNuGWN4dYxpPtXly3eRkiR3z1LTn0AUwFRwQWmhqB-f+1wK4yBOC0bo8KXmIreciuJh8rFPKxbHJFHy9ZOLcks8mmQSUAsMuSnSlKMRaE3ERDxekPENAaIwoazDnnC0WLAlWjz1U8sWPi0mOTlmis-EVKoezLAdB0HiU4s8ShaBVEvDxlRczZi0MyzVCwUXmM5Ri7lsyvWGrvsakVUhgYZmhdmCulhJDgv1EZehWJaamFVZiwNQstUcp4cfPVGaDUDxvlKFxRsTXhrTJGrMOZY2UIaEWVQ5hPzjIRPZaZlF83euzei3N+j9ULGDVk4VMjkwRo8VG6teZZ6FHUCcWhoLDApk9ZmztZiD45sSe205McC1iKLQbOqobh0pgrWOqtMbJ11HEoJXERRrKPDMAiJdvsRaABExwAMx0B21e3DdmMEWvo-TrQtXypFEqTGKnEErgVSrBbPRE8ITBElNH0RU7t6mbr-e+z9ty27wN1b2jNz7MOAd3V8kteCy1-NJZBqy0GqWXv-n5QojL+rGGNE+85RGFbYfuQg-DW7sWIs4wOpCQ7fngbJVB0FdGfL3DnNmJ4zwKwGDxOxwTAHA6rrRQk9N-HeVCaA4KkDbjNLieoxSmDdRxm5DodbS4zxZVFFU-+z9XbtMBt04R9TwmyM-OJf8iDQKaNSbtgzdQJQgpWXEoaSsS7FiABG1kWgIhaAAk1kWgAUHtCIAABqPDtMPb81jpQnWqEetUGEt67adCLo0fEvU3pvViwsBLgAH3sAC2j6Wss5cJcZ9Kx70ynoOROuNs9DKOs-BcJ406PEWBOc5QAGqudaM7kx+mdn6WzfhiUoTQbXZlUP+PZj1dFqr43NzrPnQOaSftnNb09351AaOU5Dn4KzCWqTN+SgARVciC3bjOqf3g2cp94jnzDOiYzu0Isxp6WbkeAqsyRg1DfkNCYCVdK3tyUBxp1F8SuV5vih9r7-cSMg46dOAr6ZCjFcVLJ8rfFUxFTUUSFMybb3VjbZjQAC6OABv2wAGTOABrOr9uG-txS53z4Ti2KNk6K8BUrxR8qWYKPTwGZQgrW1bWhjnPP+euZx3xkXvOxeg6TJLin0vqdy66VTdMrHKi6BhKm1DR2ZlqD+IwXLpaw2YkNOuPprQeg5DpvmdQWJNyGDaMSCoJzWuABIxwAEKtu-Ix71MQUcREnuLoVjLRpOYmNOom2NHeptEjy12PiySdjxW1dqeNt8JKvhLCBD4lRknJaW0rrS3ZEFK8aQnxyj8I6SKmYWV-uYts-Bi30veXpz5KIQo7vMhe98XuBXZo9DPwxptc3+Zrfsnu+HdPwp3j58lLu1+a40UWjQvuGm9z4+mAHt378-fXfil+OTIYAfZRsipkQyP9XY+t8giSCG4EKd6z4v5mTfgI5KoljfgGBq6O6bq356DAF5KeJgE97H7hpUwaA3AMxPCsaGSOaj5xS37GAoGZBP7oFH6v5LxmzFCkJvSZSbhEF-4kEAFMBaDkEd4z5FIYE0GWQqhdA6TIhdD-zwE6a35KBcFaRoG8HUEYgVjGgQ5X5WrJrX64635FDSGUFyG+IKEagI4pgKJ1ZEib6BALJuTi4e46GH56GL6VDWY2zFiGA9DvRmEWEVDaGyG2EL6qI5DqAkJVCMy3qGjqF8a36aheGgG6G+GICKrph4jMFiQeK3osEIGYy9iAA-E4AJGrIsHggAHz21xBAiyAAEg4ALsLWGm0v2OmWRuRBRRRgQpRFRQOAqmSbeFGpmgW5mWepsTQ1QeIDQ-4rQ-8JytReRhR1ITRlRdy1R7mYx9Rkx5RV8BmbRZ23Woq-mEmQW0qtOioVwSICilgSmYRTu8xExxRSx32VR36NROR4xDRUxLR4iUoO+Cew6nRkqwWfEVQ70OyeBTOUaoxdxCxFxzRmOvq66txdR5xjRlxhOwObRVh7xmxZmtGcOugagey1QuwHiAydS6R4MZxDxcJPqa63aQuwYRJixYJ3m0hHxkmOxdQxQSo9ajwlwByAyUyrBwYbggAN6MeCAAgNSLIADOdH6FhSJvy3SRYvSdM2gAyNBVMVwaYoy2JV+JyfJgpIpYpreax7eWQqy0p6ycpmy3xBQcIGen4hodkHqxBPJ-JQpop0xOGDyFJlIGpDpXmKxBKEp04HJ6g1sTwVQJUj0b0ZkrQ5OOcTw5CaY6p9pWpLmmm2O-quO7p8ZTxe6kidJKJXRaJ3xmeghzweIBQOkMIsZmpjpe8iZfqPaTuqZFZ8JrRBKupHR2ZnxjJUgMg16bQQUlYxcpZtplIopsQIs-YgAGs2AAqayLIACdNgAMuOTkkk-Y3HuZDkjkTnTlzmPENnPEhoP6+kGk0x9LGmDLfQNCCS4ElyD75DHIDnjArljmTmznzlgkC4uk6Z3lrmPmbm0ll4matkMkWYKhlBhbvQTKWAlDmAnLvkPkbkkna7Jl8ZQXrlPnLFE6IlZlUY5lfF3YMxwhskw7Zy274lvlvrDn3lIWbmklaY65O6IWflwnfmT5gZ-nbEAX1CqBW6dkNrv4b43m2hBCAA1A-4C+bxk7tSIJQbj+T1qOpmANuekNkyQWIJJqCUAuhYG0GYGYYJZRUmTWYgQJf4BJYxZpL1pWrJbmPJQqIckWP+LapqGVtNrxSGIEIsIAPA9Wli5guEhQQrl4lXpRqu5SYJl-W0a5lChFYRCQZn4+2NCrO3JlI1IPlQlcFulmMCVCwblBlflO5bxvyQVMlIVNa30Vpf0ZgAMquwMZhiV2l1ZrpfI3l6VvlqFTZ0heV46clChB2COyIfQ-82cqOjlLe8sAA8iQCQL7H8PHr5kmFKQebKRMseXUFZPoDgW9KWOUBXO4XJMNaNeNREBPgFZpDNTKRsgtecKnlAc8ESPkGyScXpeYVtXLCNWNb8HtSJpJTsPucdUea-pYIWH0Eqk8P3jxXFXVfddtc9QsBNXftIUdUafNT9RWEVOHnTEYP-MSDaSDXxWDY9TtS9eEIATDZ9XDfKfhDCivmYEqDpC9ERTfvVYABnLvggAA5O+CACbzZNedulPSSxVnkBU0MiMSEchFiSI5eUYsFcTMUubjqLQsOmcBuheKphe2QgIquuAuGvoZM8FyQSXFNLeLc6SJZurrVuRmUKu9QqMxd0RthMhoAcqoESAFNoCckbcJXhk7kbcJq8VNb+RhW2axVZBWpFNnIkcSGkTps7R5a+e5u7VlTgvfjlX5j7f+TzQpkWMSNzKiM9odmHWUWLeCWSW5lLTnTLcbXLWbZRgrb7T0TcEVKQsBJrQRU7UXZWVjjVdnbnQxQdZzRbbmYteBUWFzIUBcKYHTMyuUXrTxq7ehjMGPSXcTkZVJSevlYNhtjal-D1RNg0KQliKPWUc3RCeSTprMDPYZZ3ZkK1WeqFbTtkOTlZEFISCWPcDvXvfndRVPcfTHabfPWfdJW1ZfYtaeTiO0MWa-NnMysliXu0YnhXpPK-DdhtrUv3aeWUiWQUJtcNQAHK7X42QPDqw2Hnw34T+b3BUyGh6RD6LoDVb4YNYP7Xx3TVE34Mk2L7+F5CQ7HAlj15oOPWYN41JSE3YGzUnUI0wjSkGAFg3AmAnIMDDiBCCWtLj2zG47SOyP+DyOz1oVl1c2W2L6XBfyNAOFYjEIHJSMyNyMPXVWQnubKNmOy1z2n3m2J3c34T0H923qNBtAMEY3a3BjWOqPmPJW1WuC+NqMd10Pe0V1J2EP-gaCgSPTWyo1a06aAAJc-8IAJWzgAIBNOkT2BNqApMZMoUInenSGXYwNWzV4FQU5QEwgGBKjIimgnJ5OZPP1UXwVO6NMFONn+VhPpQlMvxlMzyWY5hEQjaVj-xGAj6DRCAUAQBwCiDppl0AC0WeSzXVCmaz6zXjOmngXgZdMg+hVwMgiGvVhkVOzKeNQIZdOQkKFQFwt69teyWgzjVw119KMa1Qt1qVoY9ouznVVM6Nek7Jxo+YAEwkKISmpUNNuOUENE54dEV4N4w4lzShNkwM7JCGFl-EhEEj-1+Ib0nQaOykZd9s6gDMHjQUsqdhqiOk1l+QMgWolpiT7mkMqSIiZdlYy+Nq1qkOW9t2XSFwuQqgmgxwyu5EjlCK-s8sSLYkxUkOnLkOGIn4jq70lYZQjK70BYT6Pc28fcuzt6jqr096HQhoLQ4KJQGgS8t6pQVNNq4h7mkSQiMSa0RLRwBopYHjXMF65wjQ1wr0xQMB2QDuh9cy91bLRo0psIZgMa-tr++yjqpDhotTSo3UTmbKq0mjlY6gXQ+gKrWImodql6Byjq222gfzLaGlYr26CwPzZQzQlw5gluLaGLpomggSjwBYeyqIxITmnG6by1aYA9n0poQUIWeyzQCIdl7JSmsV3jGqy6CWSWqWGW2WlzpCzzPQfSRIoWjzs8CumJWIX+dOxYKmFbXqzWbWS7HgPzyoBypQ1sm2dLdsNlBoeI-hqR2gWd7mJ2lzoRCOJzC42YQDX0TJhENsfQWIJQqRbGjlAOBOK71QtbMImoVYKY27TJfQXVsaA2q8j9jleuK7hEQSpLiohQn0+YlwKo70lOTw5gsqJyLuDAZd70moOINsmgv1dTFWM6PZ3exw2kod7m0eMeSLhYc8ilHQ1Qn4NenUekjBm4u2VQkL4RW+RLFLe78bbHZpqHUgO4EOYkgHlNQJ0JxJYJmjY6COekP0V52YNwZkeLGgFLjMrQuIgb7mdZ2pobRIqd2gpQxIVqxYEBASgZWioePQ-HKZcZ9Z6bKYGgD6dtPZYkYZVQKeZCYkj0G1jltFMFJnX9Co+QVwrQ9eIhzq5gCh1t9MLQzwFwwKml-gV7fWpVTwSG9mChtqCObQ-SRksqjLGh9VGVV7JLqg+eJDRIHVZs-NDw-ulg+LlD2NT1WDbLQz+gNMenFcXQNe5HLQwx7M24LnPXzlCwDNzNLN6bBgmJjMFgPxKGDQ+ELQYUoR3eq9cKItTdcsvbuFnQlKqXaNG2qgZ55QwhaXFwT9r3OXyYlYuQBQJDlgxY7JK9lYeQnbOkP8VQ3XfGsw4DQnoPqYqYhh-4rGG4oe8DyebHhUFcP8XDQ1PDkNEQC3ekMXBQhbCmoUhDHiGYKLRk0aH7SjpjfjkroPNCRUoUSIMgFcerzjZrfQhb2QeIYFDTaTTTIP9jytquzQiNYFS8OQWnWQS8jqDqFYJUBE+gNgNgQAA */
  id: 'buyTicketFlow',
  initial: '대기중',
  context: initialContext,
  on: {
    취소: {
      target: '.플로우취소',
    },
  },
  states: {
    대기중: {
      entry: 'clearContext',
      on: {
        이용권플로우요청됨: {
          target: '이용권플로우시작',
          actions: 'initializeTicketProcessContext',
        },
        세트구매요청됨: {
          target: '세트구매플로우시작',
          actions: 'initializeBuySetProcessContext',
        },
      },
    },

    세트구매플로우시작: {
      entry: 'callOnInit',
      always: {
        target: '로그인체크',
      },
    },

    이용권플로우시작: {
      entry: 'callOnInit',
      invoke: {
        src: 'fetchSeriesSingleInfo',
        input: ({context}) => ({
          queryClient: context.queryClient,
          ticketProcessParam: context.ticketProcessParam,
        }),
        onDone: {
          target: 'seriesSingleInfo정보저장',
          actions: 'setSeriesSingleInfo',
        },
        onError: {
          target: '에러처리',
          actions: 'setError',
        },
      },
    },

    seriesSingleInfo정보저장: {
      always: [
        {
          guard: 'if 웹 접근 불가',
          target: '에러처리',
          actions: 'setWebNotAccessibleError',
        },
        {
          guard: 'if 연령제한',
          target: '에러처리',
          actions: 'setAgeNotGrantedError',
        },
        {
          guard: 'if 무료 & 19세 미만 작품 & 판매중',
          target: '뷰어오픈',
        },
        {
          target: '로그인체크',
        },
      ],
    },

    로그인체크: {
      always: [
        {
          guard: 'if isAnonymous',
          target: '로그인하기',
        },
        {
          guard:
            'if 로그인 & 이용권 구매 플로우 & 뷰어 내부 & 이용권 구매 후 바로보기',
          target: '이용권사용',
        },
        {
          guard: 'if 로그인 & 이용권 구매 플로우',
          target: 'readyToUseAPI호출',
        },
        {
          guard: 'if 로그인 & 세트 구매 플로우',
          target: 'setReadyToUseAPI호출',
        },
      ],
    },

    readyToUseAPI호출: {
      invoke: {
        src: 'fetchReadyToUse',
        input: ({context}) => ({
          context,
        }),
        onDone: {target: '이용권확인', actions: 'setReadyToUseTicket'},
        onError: {
          target: '에러처리',
          actions: 'setError',
        },
      },
    },

    세트상품_구매제한_팝업: {
      invoke: {
        src: 'showSetAllOwnedPopup',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '세트상품구매후_작품홈_바로가기',
        },
        onError: {
          target: '플로우취소',
        },
      },
    },

    세트상품_이미구매한상품_팝업: {
      invoke: {
        src: 'showSetAlreadyPurchasedPopup',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '세트상품구매후_작품홈_바로가기',
        },
        onError: {
          target: '플로우취소',
        },
      },
    },

    setReadyToUseAPI호출: {
      invoke: {
        src: 'fetchSetReadyToUse',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '세트이용권확인',
          actions: 'setSetReadyToUseTicket',
        },
        onError: [
          {
            guard: 'if 세트의_모든_회차_소장중_에러 발생',
            target: '세트상품_구매제한_팝업',
          },
          {
            guard: 'if 이미_구매한_세트상품_에러 발생',
            target: '세트상품_이미구매한상품_팝업',
          },
          {
            target: '에러처리',
            actions: 'setError',
          },
        ],
      },
    },

    세트이용권확인: {
      always: [
        {
          guard: 'if 저장된 이용권 정보 존재',
          target: '세트상품구매',
          actions: 'setSetBuyTicketInfoFromStoredTicketInfo',
        },
        {
          target: '세트상품_구매_팝업_노출',
        },
      ],
    },

    세트상품_구매_팝업_노출: {
      invoke: {
        src: 'showSetBuySelectPopup',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '세트상품구매',
          actions: 'setSetBuyTicketInfo',
        },
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },

    세트상품구매: {
      invoke: {
        src: 'fetchSetBuy',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '세트상품_구매_완료_팝업',
          actions: 'setSetBuyResult',
        },
        onError: [
          {
            guard: 'if 세트의_모든_회차_소장중_에러 발생',
            target: '세트상품_구매제한_팝업',
          },
          {
            guard: 'if 이미_구매한_세트상품_에러 발생',
            target: '세트상품_이미구매한상품_팝업',
          },
          {
            guard: 'if 이용권_구매_캐시_부족_에러 발생',
            target: '캐시충전_팝업',
          },
          {
            target: '에러처리',
            actions: 'setError',
          },
        ],
      },
    },

    세트상품_구매_완료_팝업: {
      entry: 'callOnSuccess',
      invoke: {
        src: 'showSetBuyCompletePopup',
        input: ({context}) => ({
          context,
        }),
        onDone: [
          {
            guard: 'if 구매완료팝업_작품홈가기 노출',
            target: '세트상품구매후_작품홈_바로가기',
          },
          {
            guard: 'if 구매완료팝업_뷰어가기_노출',
            target: '세트상품구매후_뷰어_바로가기',
          },
          {target: '플로우취소'},
        ],
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },

    세트상품구매후_작품홈_바로가기: {
      always: {
        actions: 'goToSeriesHome',
        target: '플로우취소',
      },
    },

    세트상품구매후_뷰어_바로가기: {
      always: {
        actions: 'goToViewerAfterSetBuy',
        target: '플로우취소',
      },
    },

    로그인하기: {
      always: [
        {
          guard: 'if 로그인 팝업 미노출',
          target: '로그인필요팝업',
        },
        {
          actions: 'login',
          target: '플로우취소',
        },
      ],
    },

    로그인필요팝업: {
      invoke: {
        src: 'showNeedLoginPopup',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '로그인하기',
          actions: 'setLoginPopupConfirm',
        },
        onError: {
          target: '플로우취소',
        },
      },
    },

    에러처리: {
      entry: 'callOnError',
      invoke: {
        src: 'handleError',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '플로우취소',
        },
        onError: {
          target: '플로우취소',
        },
      },
    },

    플로우취소: {
      always: {
        target: '대기중',
        actions: 'callOnFlowComplete',
      },
    },

    뷰어오픈: {
      entry: 'callOnSuccess',
      always: [
        {
          guard: 'if 뷰어 외부',
          actions: 'goToViewer',
        },
        {
          guard: 'if 뷰어 내부',
          target: '플로우취소',
        },
      ],
    },

    이용권확인: {
      always: [
        {
          guard: 'if 열람 권한 유효 (RAT2)',
          target: '뷰어오픈',
        },
        {
          guard: 'if 뷰어 외부 & 무료회차 (RAT4)',
          target: '뷰어오픈',
          description:
            '연재 무료회차는 이용권을 사용해야 하는데 뷰어 외부/내부에서 두번 호출하면 안되기 때문에 내부에서만 호출',
        },
        {
          guard: 'if 뷰어 내부 & 무료회차 (RAT4)',
          target: '이용권사용',
          description: '로그인 유저가 무료 회차 진입 시 useTicket APi 호출',
        },
        {
          guard: 'if 보유한 세트 이용권 존재',
          target: '이용권사용',
          actions: 'setSetUseTicketByPriority',
          description: '세트이용권이 있으면 이용권 바로 사용',
        },
        {
          guard: 'if 만료(RAT3) & 만료컨펌(expiredConfirmed) 체크 미완료',
          target: '대여기간_만료_확인',
        },
        {
          guard: 'if 정주행 & 대여권 보유',
          target: '이용권사용',
          actions: 'setUseTicketTypeRentalType',
          description: '대여권 -> 소장권 순으로 사용',
        },
        {
          guard: 'if 정주행 & 소장권 보유',
          target: '이용권사용',
          actions: 'setUseTicketTypeOwnType',
        },
        {
          guard: 'if 정주행 & 기본 이용권 미선택',
          target: '정주행_기본_이용권_선택_팝업',
        },
        {
          guard: 'if 정주행 & 기본 이용권 선택',
          target: '이용권구매및사용',
          actions: 'setNonstopWatchingBuyAndUseTicketInfo',
        },
        {
          guard: 'if 저장된 이용권 정보 존재',
          target: '이용권구매및사용',
          actions: 'setBuyAndUseTicketInfoFromStoredTicketInfo',
        },
        {
          guard: 'if 이용권_확인_팝업_OFF',
          target: '이용권확인팝업OFF_구매플로우',
        },
        {
          guard: 'if 이용권_확인_팝업_ON',
          target: '이용권확인팝업ON_구매플로우',
        },
        {
          target: '선택구매팝업',
        },
      ],
    },
    정주행_기본_이용권_선택_팝업: {
      invoke: {
        src: 'showNonstopWatchingSelectTicket',
        input: ({context}) => ({
          context,
        }),
        onDone: [
          {
            guard: ({event}) =>
              event.output.type === 'SET' && event.output.isMultiple,
            target: '세트선택팝업',
          },
          {
            guard: ({event}) =>
              event.output.type === 'SET' && !event.output.isMultiple,
            target: '세트홈오픈',
          },
          {
            target: '이용권구매및사용',
            actions: [
              'setselectedNonstopWatchingBuyTicketInfo',
              'setNonstopWatchingBuyAndUseTicketInfo',
            ],
          },
        ],
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },
    대여기간_만료_확인: {
      always: [
        {
          guard: 'if 만료(RAT3) & 회차 끝까지 읽었거나 회차 선택 완료',
          target: '대여기간_만료_팝업',
        },
        {
          target: '만료됨_보던화_다음화_선택_팝업',
        },
      ],
    },

    대여기간_만료_팝업: {
      invoke: {
        src: 'showExpiredPopup',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '이용권확인',
          actions: 'setExpiredConfirmed',
        },
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },

    만료됨_보던화_다음화_선택_팝업: {
      invoke: {
        src: 'showProductChoiceCauseExpired',
        input: ({context}) => ({
          context,
        }),
        onDone: [
          {
            guard: 'if 보던화 선택',
            target: '이용권확인',
            actions: 'setExpiredConfirmed',
          },
          {
            guard: 'if 다음화 선택',
            target: '이용권플로우시작',
            actions: 'startNextTicketProcess',
          },
        ],
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },
    이용권사용: {
      invoke: {
        src: 'useTicket',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '뷰어오픈',
        },
        onError: [
          {
            guard: 'if 이미_보유한_회차_에러 발생',
            target: '뷰어오픈',
          },
          {
            target: '에러처리',
            actions: 'setError',
          },
        ],
      },
    },
    이용권구매및사용: {
      invoke: {
        src: 'buyAndUseTicket',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '뷰어오픈',
        },
        onError: [
          {
            guard: 'if 이용권_구매_캐시_부족_에러 발생',
            target: '캐시충전_팝업',
          },
          {
            target: '에러처리',
            actions: 'setError',
          },
        ],
      },
    },

    이용권확인팝업OFF_구매플로우: {
      always: [
        {
          guard: 'if 소장권만 보유',
          target: '이용권사용',
          actions: 'setUseTicketTypeOwnType',
        },
        {
          guard: 'if 대여권만 보유',
          target: '이용권사용',
          actions: 'setUseTicketTypeRentalType',
        },
        {
          guard: 'if isCashTypeReadyToUse',
          target: '선택구매팝업',
          description:
            '캐시타입은 이용권이 없기 때문에 이용권 팝업 ON/OFF 관계 없이 구매 팝업을 보여줍니다',
        },
        {
          guard: 'if 대여권 및 소장권 미보유',
          target: '이용권구매페이지이동',
        },
        {
          target: '선택구매팝업',
        },
      ],
    },

    이용권구매페이지이동: {
      always: {
        actions: 'goToBuyTicket',
        target: '플로우취소',
      },
    },

    선택구매팝업: {
      invoke: {
        src: 'showTicketChoicePopup',
        input: ({context}) => ({
          context,
        }),
        onDone: [
          {
            guard: ({event}) => event.output.type === 'USE',
            target: '이용권사용',
            actions: 'setUseTicketType',
          },
          {
            guard: ({event}) => event.output.type === 'BUY_AND_USE',
            target: '이용권구매및사용',
            actions: 'setBuyAndUseTicketInfo',
          },
          {
            guard: ({event}) =>
              event.output.type === 'SET' && event.output.isMultiple,
            target: '세트선택팝업',
          },
          {
            guard: ({event}) =>
              event.output.type === 'SET' && !event.output.isMultiple,
            target: '세트홈오픈',
          },
        ],
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },
    세트선택팝업: {
      invoke: {
        src: 'showSetListDialog',
        input: ({context}) => ({
          context,
        }),
        onDone: {
          target: '세트홈오픈',
        },
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },
    세트홈오픈: {
      always: {
        actions: 'goToSetHome',
        target: '플로우취소',
      },
    },
    이용권확인팝업ON_구매플로우: {
      always: [
        {
          guard: 'if 이용권타입인데 대여권, 소장권 둘다 미보유',
          target: '이용권구매페이지이동',
        },
        {
          guard: 'if 소장권만 보유',
          target: '소장권사용확인팝업',
        },
        {
          target: '선택구매팝업',
        },
      ],
    },

    소장권사용확인팝업: {
      invoke: {
        src: 'showAskOwnTicketUse',
        input: ({context}) => ({
          context,
        }),
        onDone: [
          {
            target: '이용권사용',
            actions: 'setUseTicketTypeOwnType',
          },
        ],
        onError: [
          {
            guard: 'if 에러발생',
            target: '에러처리',
            actions: 'setError',
          },
          {
            target: '플로우취소',
          },
        ],
      },
    },

    캐시충전_팝업: {
      invoke: {
        src: 'openCashCharge',
        input: ({context}) => ({
          context,
        }),
        onDone: {target: '플로우취소'},
        onError: {
          target: '에러처리',
          actions: 'setError',
        },
      },
    },
  },
});

export let xstateInspector:
  | ReturnType<typeof createBrowserInspector>
  | undefined;

export const getXstateInspector = () => {
  if (xstateInspector) {
    return xstateInspector;
  }
  xstateInspector = createBrowserInspector({autoStart: false});
};
